import { createFilterSlice } from './filterSlice';

const STORAGE_KEY = 'renewalReportFilters';
const defaultDebtorsFilters = {
	fromDate: null,
	toDate: null,
	ownerIds: [],
	brokerGroupId: null,
};

export const renewalReportPrefsSlice = createFilterSlice({
	sliceName: 'renewalReportPrefs',
	storageKey: STORAGE_KEY,
	defaultFilters: defaultDebtorsFilters,
});

export const { setFromDate, setToDate, setOwnerIds, setBrokerGroupId, resetFilters } =
	renewalReportPrefsSlice.actions;

export default renewalReportPrefsSlice.reducer;
